export default __webpack_public_path__ + "static/media/p1.c2bc5234.PNG";